/* ========================================== Start Of Header Fixed Javascript ========================================== */
jQuery(window).scroll(function () {
    if (jQuery(window).scrollTop() >= 100) {
        jQuery('header').addClass('fixed-header');

    } else {
        jQuery('header').removeClass('fixed-header');

    }
});
/* ========================================== End Of Header Fixed Javascript ========================================== */


/* ========================================== Start Of Menu Active Class ========================================== */
jQuery("ul li a").filter(function(){
  return this.href == location.href.replace(/#.*/, "");
}).closest("li").addClass("active");
/* ========================================== End Of Menu Active Class ========================================== */


/* ========================================== Start Of Slick Slider Javascript  ========================================== */

jQuery('.hero-slider').slick({
    infinite: true,
    arrows: false,
    dots: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [{
            breakpoint: 767,
            settings: {
                arrows: false,
                dots: true,
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
});


jQuery('.hero-slider-new').slick({
    infinite: true,
    arrows: true,
    dots: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    prevArrow: '<button class="slide-arrow prev-arrow">PREV</button>',
    nextArrow: '<button class="slide-arrow next-arrow">NEXT</button>',
    responsive: [{
            breakpoint: 992,
            settings: {
                arrows: false,
                dots: true,
                slidesToShow: 1,
                slidesToScroll: 1
            }
        },
                 {
            breakpoint: 767,
            settings: {
                arrows: false,
                dots: true,
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
});


jQuery('.brands-slider').slick({
    infinite: true,
    arrows: false,
    dots: false,
    slidesToShow: 5,
    slidesToScroll: 5,
    autoplay: true,
    autoplaySpeed: 5000,
    responsive: [{
            breakpoint: 767,
            settings: {
                arrows: false,
                dots: false,
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
});

jQuery('.brands-slider-new').slick({
    infinite: true,
    arrows: false,
    dots: false,
    rows: 2,  
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [{
            breakpoint: 767,
            settings: {
                arrows: false,
                dots: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                rows: 1,
            }
        }
    ]
});


jQuery('.testimonials-slider').slick({
    infinite: true,
    arrows: false,
    dots: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1000,
    responsive: [{
            breakpoint: 992,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,

            }
        },
        {
            breakpoint: 767,
            settings: {
                arrows: false,
                dots: true,
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
});

jQuery('.product-slider').slick({
    infinite: true,
    arrows: true,
    dots: false,
    slidesToShow: 4,
    slidesToScroll: 4,
    responsive: [{
            breakpoint: 992,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2,

            }
        },
        {
            breakpoint: 767,
            settings: {
                arrows: false,
                dots: true,
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
});

jQuery('.mobile-slider').slick({
    infinite: true,
    arrows: false,
    dots: true,
    slidesToShow: 2,
    mobileFirst: true, 
    responsive: [
       {
          breakpoint: 767,
          settings: "unslick"
       }
    ]
});

/* ========================================== End Of Slick Slider Javascript ========================================== */

/* ========================================== Start Of Menu Target Blank Javascript  ========================================== */
jQuery('.Training a').attr('target', '_blank');
jQuery('.Corporate a').attr('target', '_blank');
/* ========================================== End Of Menu Target Blank Javascript ========================================== */

/* ========================================== Start Of Menu Categories Text Replace Javascript  ========================================== */
jQuery('.CATEGORIES a span').text('Products');
jQuery('.CATEGORIES .navigation-mobile-item-link a span:first').text('Products');
/* ========================================== End Of Menu Categories Text Replace Javascript ========================================== */

/* ========================================== Start Of Match Height Javascript  ========================================== */
function MatchHeight() {
  jQuery('.match').matchHeight({});
  jQuery('.same-height').matchHeight({});
}

jQuery(document).ready(function(){
  MatchHeight();
});
/* ========================================== End Of Match Height Javascript ========================================== */

jQuery(".toggle-btn").on("click", function() {
var $btn = $(this);
var $content = $btn.closest(".content-box").find(".more-text");

$content.slideToggle(800); // slide open/close

// Toggle button text
if ($btn.text() === "View More +") {
    $btn.text("View Less -");
} else {
    $btn.text("View More +");
}
});

jQuery(document).ready(function(){  
   function detectDevice() {
  const ua = navigator.userAgent.toLowerCase();
  const platform = navigator.platform.toLowerCase();
  const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  const maxTouchPoints = navigator.maxTouchPoints || 0;

  const isIOS = /iphone|ipod|ipad|macintosh.*applewebkit.*safari/.test(ua) && hasTouch;
  const isAndroid = /android/.test(ua);
  const isIPad = /ipad/.test(ua) || 
                 (/mac.*like mac os x/.test(ua) && maxTouchPoints > 2 && hasTouch) ||
                 (/macintel/.test(platform) && maxTouchPoints > 2);

  const isTablet = isIPad || 
                   (/tablet|(android(?!.*mobile))|(windows.*touch)/.test(ua)) ||
                   (isAndroid && !/mobile/.test(ua));

  // Debug logging
  console.log('UA:', navigator.userAgent);
  console.log('Platform:', platform);
  console.log('maxTouchPoints:', maxTouchPoints);
  console.log('Touch supported:', hasTouch);
  console.log('Detected:', { isIOS, isAndroid, isIPad, isTablet });

  return { isIOS, isAndroid, isIPad, isTablet };
}

// Apply classes (same as before)
document.addEventListener('DOMContentLoaded', function() {
  const device = detectDevice();
  const body = document.body;
  if (device.isIOS) body.classList.add('ios');
  if (device.isAndroid) body.classList.add('android');
  if (device.isIPad) body.classList.add('ipad');
  if (device.isTablet) body.classList.add('tablet');
  console.log('Body classes added:', body.className);
});

    console.table(detectDevice());
    document.body.className;


});

